import type { Ref, RefCallback } from 'react';

/** Один элемент — несколько ссылок: своя (для автовысоты, фокуса) и переданная снаружи. */
export function mergeRefs<T>(...refs: (Ref<T> | undefined)[]): RefCallback<T> {
  return (value) => {
    for (const ref of refs) {
      if (typeof ref === 'function') ref(value);
      else if (ref) ref.current = value;
    }
  };
}
